import dayjs from 'dayjs'
import extendedObservable from './base'
import api from '../api'
import { get } from 'lodash-es'


export function AvailabilityObservable() {
  extendedObservable(this, 'availabilityModel', [])

  const getEad = item => new Promise((resolve, reject) => {
    api.availability.datesByService(item)
      .then(resolve)
      .fail(reject)
  })

  const log = data => new Promise((resolve, reject) => {
    api.logs.log(data)
      .then(resolve)
      .fail(reject)
  })

  this.on('getEad', (item) => {
    getEad(item)
      .then((response) => {
        const zip = get(item, 'shippingAddress.address.postalCode')
        const shipMethod = get(item, 'shipMethod.id')

        const byEad = get(response, 'dates[0].customerFulfillmentDates[0].fulfillmentOptions[0].deliveryDate.min')
        const byShipNode = parseInt(get(response, 'dates[0].customerFulfillmentDates[0].fulfillmentOptions[0].locations[0].locationId', 0), 10)

        const sterlingEad = get(item, 'fulfillment.fulfillmentInfos[0].ead')
        const sterlingShipNode = get(item, 'fulfillment.fulfillmentInfos[0].shipNode')
        const eadCount = get(item, 'fulfillment.fulfillmentInfos.length')

        const sterlingDate = !sterlingEad || sterlingEad === -1 ? null : dayjs(sterlingEad)
        const sterlingEadFormatted = sterlingDate ? sterlingDate.toISOString() : ''
        const byDate = byEad ? dayjs(byEad) : null
        const byEadFormatted = byDate ? byDate.toISOString() : ''
        const eadsMatch = (byDate && sterlingDate) ? sterlingDate.isSame(byDate, 'day') : (!byEad && !sterlingEad)
        let sterlingFulfillment
        let byFulfillment

        if (!sterlingEad) {
          sterlingFulfillment = 'Unavailable'
        } else if (sterlingEad === -1) {
          sterlingFulfillment = 'Error'
        } else if (sterlingShipNode < 10) {
          sterlingFulfillment = 'DC'
        } else if (sterlingShipNode > 10 && sterlingShipNode < 1000) {
          sterlingFulfillment = 'SIF'
        } else if (sterlingShipNode > 1000) {
          sterlingFulfillment = 'VIF'
        }

        if (!byEad) {
          byFulfillment = 'Unavailable'
        } else if (byShipNode < 10) {
          byFulfillment = 'DC'
        } else if (byShipNode > 10 && byShipNode < 1000) {
          byFulfillment = 'SIF'
        } else if (byShipNode > 1000) {
          byFulfillment = 'VIF'
        }

        log([{
          level: 'INFO',
          logger: 'eadShipLogger',
          message: `sku=${item.sku} qty=${item.quantity} zip=${zip} shipMethod=${shipMethod} timestamp=${dayjs().toISOString()} byShipNode=${byShipNode} sterlingShipNode=${sterlingShipNode} eadsMatch=${eadsMatch} byEad=${byEadFormatted} sterlingEad=${sterlingEadFormatted} byFulfillment=${byFulfillment} sterlingFulfillment=${sterlingFulfillment} complicatedSterlingFulfillment=${eadCount > 1}`,
        }])
      })
      .then(this.notifyObservers)
      .catch(() => {
        const zip = get(item, 'shippingAddress.address.postalCode')
        const shipMethod = get(item, 'shipMethod.id')

        const sterlingEad = get(item, 'fulfillment.fulfillmentInfos[0].ead')
        const sterlingShipNode = get(item, 'fulfillment.fulfillmentInfos[0].shipNode')
        const eadCount = get(item, 'fulfillment.fulfillmentInfos.length')

        const sterlingDate = !sterlingEad || sterlingEad === -1 ? null : dayjs(sterlingEad)
        const sterlingEadFormatted = sterlingDate ? sterlingDate.utc().format() : ''
        let sterlingFulfillment

        if (!sterlingEad) {
          sterlingFulfillment = 'Unavailable'
        } else if (sterlingEad === -1) {
          sterlingFulfillment = 'Error'
        } else if (sterlingShipNode < 10) {
          sterlingFulfillment = 'DC'
        } else if (sterlingShipNode > 10 && sterlingShipNode < 1000) {
          sterlingFulfillment = 'SIF'
        } else if (sterlingShipNode > 1000) {
          sterlingFulfillment = 'VIF'
        }

        log([{
          level: 'INFO',
          logger: 'eadShipLogger',
          message: `sku=${item.sku} qty=${item.quantity} zip=${zip} shipMethod=${shipMethod} timestamp=${dayjs().toISOString()} byShipNode= sterlingShipNode=${sterlingShipNode} eadsMatch= byEad= sterlingEad=${sterlingEadFormatted} byFulfillment=Error sterlingFulfillment=${sterlingFulfillment} complicatedSterlingFulfillment=${eadCount > 1}`,
        }])
      })
  })
}
